let S = com.ts.mobile.sdk;

function customProcessJsonData(jsonData, actionContext, clientContext, helper) {
  return new Promise((resolve, reject) => {
    let jsonForm = document.createElement("div");
    jsonForm.classList.add("text-center");

    let header = document.createElement("h4");
    header.textContent = "JSON Data received from TS Server";
    jsonForm.appendChild(header);

    let content = document.createElement("p");
    content.textContent = JSON.stringify(jsonData, null, 2);
    jsonForm.appendChild(content);

    jsonForm.appendChild(document.createElement("br"));

    let button = document.createElement("button");
    button.classList.add("btn");
    button.classList.add("btn-primary");
    button.textContent = "OK";
    button.onclick = () => {
      jsonForm.innerHTML = "";
      resolve(S.JsonDataProcessingResult.create(true));
    };

    jsonForm.appendChild(button);

    helper.presentUI(jsonForm, clientContext);
  });
}

